import { render, staticRenderFns } from "./couponDialog.vue?vue&type=template&id=2930b17d&scoped=true"
import script from "./couponDialog.vue?vue&type=script&lang=js"
export * from "./couponDialog.vue?vue&type=script&lang=js"
import style0 from "./couponDialog.vue?vue&type=style&index=0&id=2930b17d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2930b17d",
  null
  
)

export default component.exports